import React, {useEffect, useMemo, useState} from 'react';
import clsx from 'clsx';

const PHONE_SIZE = 940;

type Props = {
  appStoreUrl: string;
  currentPath: string;
  fixed: boolean;
  googlePlayUrl: string;
};

/**
 * GlobalNavigation
 *
 * @return {React.JSX.Element}
 */
export default function GlobalNavigation({
  appStoreUrl,
  currentPath,
  fixed,
  googlePlayUrl,
}: Props) {
  const [animated, setAnimated] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(fixed);
  const [visible, setVisible] = useState<boolean>(false);
  const navs = useMemo(() => {
    return [
      {
        label: '仕様',
        url: '/specs/',
      },
      {
        label: 'コラム',
        target: '_blank',
        url: '/hello/',
      },
      {
        label: 'サポート',
        target: '_blank',
        url: 'https://support.vandle.jp',
      },
      {
        className: 'AppStore',
        img: {
          alt: 'バンドルカードをAppStoreからダウンロード',
          src: '/images/logo/app_store_badge.png',
        },
        label: 'App Store',
        target: '_blank',
        url: appStoreUrl,
      },
      {
        className: 'GooglePlay',
        img: {
          alt: 'バンドルカードをGooglePlayからダウンロード',
          src: '/images/logo/google_play_badge.png',
        },
        label: 'Google Play',
        target: '_blank',
        url: googlePlayUrl,
      },
    ];
  }, [appStoreUrl, googlePlayUrl]);

  useEffect(() => {
    /**
     * handleResize
     */
    const handleResize = () => {
      if (window.innerWidth <= PHONE_SIZE) {
        setAnimated(true);
      } else {
        setAnimated(false);
      }
    };
    handleResize();
    window.addEventListener('resize', () => handleResize());
    return () => {
      window.removeEventListener('resize', () => handleResize());
    };
  }, []);

  return (
    <div className="GlobalNavigation">
      <ul
        className={clsx('GlobalNavigation_items', {
          'GlobalNavigation_items-open': toggle,
          'GlobalNavigation_items-visible': visible,
          animated,
          fadeInDown: toggle,
          fadeOutUp: !toggle,
        })}
        onAnimationEnd={() => setVisible(true)}
      >
        {navs.map((item, index) => (
          <li className="GlobalNavigation_item" key={index}>
            <a
              className={clsx('GlobalNavigation_item_anchor', item.className, {
                'GlobalNavigation_item_anchor-isActive':
                  item.url === currentPath,
              })}
              href={item.url}
              target={item.target}
            >
              {item.img ? (
                <img
                  alt={item.img.alt}
                  className="GlobalNavigation_appStore_badge"
                  src={item.img.src}
                />
              ) : (
                item.label
              )}
            </a>
          </li>
        ))}
      </ul>
      <a className="GlobalNavigation_button" onClick={() => setToggle(!toggle)}>
        <div
          className={clsx('GlobalNavigation_button_icon', {
            'GlobalNavigation_button_icon-open': toggle,
          })}
        >
          <span />
          <span />
        </div>
      </a>
    </div>
  );
}
